var React = require('react');

function InstantBookingVerification (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.104 13.06l-1.59 1.59-.91-.911M6.666 2.292V3.75m0 0H4.583c-.69 0-1.25.56-1.25 1.25v2.5m3.333-3.75h6.667m0-1.458V3.75m0 0h2.083c.69 0 1.25.56 1.25 1.25v2.5H3.333M7.5 17.083H4.583c-.69 0-1.25-.56-1.25-1.25V7.5m14.375 6.354a3.854 3.854 0 11-7.708 0 3.854 3.854 0 017.708 0z","stroke":"#0B77D5","strokeWidth":"1.5","strokeLinecap":"round","strokeLinejoin":"round"}));
}

InstantBookingVerification.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = InstantBookingVerification;

InstantBookingVerification.default = InstantBookingVerification;
